import If from "components/common/If";
import { useParams } from "react-router-dom";

const UnauthorizedPage = (props: {reason?: string}) => {
    const params = useParams<{reason?: string}>();
    return (
        <div>
            <h1>Unauthorized</h1>
            <If condition={params.reason || props.reason}>
                <span>
                    {params.reason || props.reason}
                </span>
            </If>
        </div>
    );
};

export default UnauthorizedPage;
